module.exports = __webpack_public_path__ + "static/media/objective2.90f9becc.svg";